import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Typography, Box, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { WatchActions } from "../../../../state";
import { format_Word } from "../../../../lib";
import { EditWatchDetails, GroupTransferList } from ".";

const useStyles = makeStyles((theme) => ({
  card: {
    maxWidth: 1400,
    margin: '0 auto',
    padding: theme.spacing(3),
    borderRadius: 8,
    border: '1px solid rgba(0,0,0,0.08)',
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
  },
}));

export function WatchDetailsGroups(props) {
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const siteId = useSelector((state) => state.scopes.site_id);

  const {
    pageRoute: {
      params: { attribute, id, detail, brand },
    },
  } = props;

  const [editBrand, setEditBrand] = useState();
  const [groupId, setGroupId] = useState();
  const [editName, setEditName] = useState(detail);
  const [myBrandId, setMyBrandId] = useState();
  const [groupDetailsData, setGroupDetailsData] = useState();
  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    (async function () {
      // Always load ALL connected watches regardless of status (matches the
      // "All Watches"-toggle removal — the active-only default relied on a
      // stale statuses.ACTIVE constant that filtered to the wrong status).
      const data = await WatchActions.getDetailsGroups(attribute, id, siteId, false, true);
      setRows(data);
      const brand = await WatchActions.getDetailsValue(
        attribute,
        id,
        true,
        siteId,
      );
      if (brand) {
        setGroupId(brand[attribute + "_id"]);
        setEditBrand(brand.brand_id);
      }
    })();
  }, [attribute, id, siteId]);
  return (
    <Box style={{ width: "100%" }}>
      <Box display="flex" justifyContent="center" mb={2}>
        <Typography variant="h6">
          {format_Word(attribute) + " — " + detail + " (ID: " + id + ")"}
        </Typography>
      </Box>
      <Paper className={classes.card}>
        <EditWatchDetails
          attribute={attribute}
          brandTitle={brand}
          id={id}
          detail={detail}
          rawAttribute={attribute}
          path={
            detail === "series_group"
              ? "watch-attribute-affiliated"
              : "watch-attribute-groups"
          }
          setEditName={setEditName}
          setEditBrand={setEditBrand}
          setGroupDetailsData={setGroupDetailsData}
          myBrandId={myBrandId}
          setMyBrandId={setMyBrandId}
          setIsDisabled={setIsDisabled}
          isDisabled={isDisabled}
        />
        <GroupTransferList
          groupId={groupId}
          series={rows}
          attribute={attribute}
          editName={editName}
          editBrand={editBrand}
          groupDetailsData={groupDetailsData}
          setGroupDetailsData={setGroupDetailsData}
          myBrandId={myBrandId}
          setIsDisabled={setIsDisabled}
          isDisabled={isDisabled}
        />
      </Paper>
    </Box>
  );
}
